var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.075 0L6 5.746 10.925 0 12 1.23l-6 7-6-7L1.075 0z",
    fill: "#75757D"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjA3NTI3IDAuMDAwMTAwMTM0TDYgNS43NDU2MkwxMC45MjQ3IDAuMDAwMTAwOTk1TDEyIDEuMjI5NDlMNiA4LjIyOTQ5TDEuNjk3NzVlLTA2IDEuMjI5NDlMMS4wNzUyNyAwLjAwMDEwMDEzNFoiIGZpbGw9IiM3NTc1N0QiLz4KPC9zdmc+Cg==";
export { SvgDownArrow as ReactComponent };